// Auto generated file, do not manually modify!
// com.hotpads.capps.enums.UserStatusType

export enum UserStatusType {
  BACKGROUND_REPORT = 'BACKGROUND_REPORT',
  CREDIT_REPORT = 'CREDIT_REPORT',
  ID_VERIFICATION = 'ID_VERIFICATION',
  RENTAL_APPLICATION_PAYMENT = 'RENTAL_APPLICATION_PAYMENT',
}

export const UserStatusType_values = [
  UserStatusType.BACKGROUND_REPORT,
  UserStatusType.CREDIT_REPORT,
  UserStatusType.ID_VERIFICATION,
  UserStatusType.RENTAL_APPLICATION_PAYMENT,
] as const;
